import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_CARDS_SERVER } from '@/app/module/payments/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetCreditCards = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getOrgPaymentsCreditCards.useQuery({ orgId: orgId.toString() })

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-cards': {
          type: 'error',
          message: ERROR_GET_CARDS_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
